import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { appApiResources } from '../../../configuration/app.constants';

@Injectable({
  providedIn: 'root'
})
export class ContactListService {

  constructor(private http: HttpClient) { }

  async getAllList(search, start, length, order, query, filter, remoteContactList) {
    try {
      let data = {
        search: search.search,
        search_column: search.search_column,
        order_direct: order.order_direct,
        order_column: order.order_column,
        start: start,
        length: length,
        ...filter
      }
      const httpOptions = {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "description": "application/json",
          "type": "text",
          "enabled": "true"
        })
      };
      if (remoteContactList) {
        let response = await this.http
          // .get(`${appApiResources.getDonationList}?search=${search.search}&search_column=${search.search_column}&order_direct=${order.order_direct}&order_column=${order.order_column}&start=${start}&length=${length}&offering_type_id=${query.offerType}&bank_id=${query.bank}&from_date=${query.fromDate}&end_date=${query.toDate}&mode_id=${query.mode}&amt_greater=${query.amtGreater}&amt_lesser=${query.amtLesser}&event_id=${query.receiptEvent}&event_offering_type_id=${query.offeringTypeEventBased}`)
          // .get(`http://officetest.ezekiahfrancis.org/onlineoffreqs?search=${search.search}&search_column=${search.search_column}&order_direct=${order.order_direct}&order_column=${order.order_column}&start=${start}&length=${length}&offering_type_id=${query.offerType}&bank_id=${query.bank}&from_date=${query.fromDate}&end_date=${query.toDate}&mode_id=${query.mode}&amt_greater=${query.amtGreater}&amt_lesser=${query.amtLesser}&event_id=${query.receiptEvent}&event_offering_type_id=${query.offeringTypeEventBased}&status=${query.status}`)
          // .get("http://officetest.ezekiahfrancis.org/printlabels?event_id=0&role_id=1&language_id=0")
          // .post(`${appApiResources.contactList}?search=${search.search}&search_column=${search.search_column}&order_direct=${order.order_direct}&order_column=${order.order_column}&start=${start}&length=${length}&${filter}`)
          .post(`http://officetest.ezekiahfrancis.org/getpartners1`, data, httpOptions)
          .toPromise();
        return response;
      } else {
        let response = await this.http
          // .get(`${appApiResources.getDonationList}?search=${search.search}&search_column=${search.search_column}&order_direct=${order.order_direct}&order_column=${order.order_column}&start=${start}&length=${length}&offering_type_id=${query.offerType}&bank_id=${query.bank}&from_date=${query.fromDate}&end_date=${query.toDate}&mode_id=${query.mode}&amt_greater=${query.amtGreater}&amt_lesser=${query.amtLesser}&event_id=${query.receiptEvent}&event_offering_type_id=${query.offeringTypeEventBased}`)
          // .get(`http://officetest.ezekiahfrancis.org/onlineoffreqs?search=${search.search}&search_column=${search.search_column}&order_direct=${order.order_direct}&order_column=${order.order_column}&start=${start}&length=${length}&offering_type_id=${query.offerType}&bank_id=${query.bank}&from_date=${query.fromDate}&end_date=${query.toDate}&mode_id=${query.mode}&amt_greater=${query.amtGreater}&amt_lesser=${query.amtLesser}&event_id=${query.receiptEvent}&event_offering_type_id=${query.offeringTypeEventBased}&status=${query.status}`)
          // .get("http://officetest.ezekiahfrancis.org/printlabels?event_id=0&role_id=1&language_id=0")
          // .post(`${appApiResources.contactList}?search=${search.search}&search_column=${search.search_column}&order_direct=${order.order_direct}&order_column=${order.order_column}&start=${start}&length=${length}&${filter}`)
          .post(`${appApiResources.contactList}`, data, httpOptions)
          .toPromise();
        return response;
      }
    } catch (error) {
      return error;
    }
  }

  async getAllContactList(search) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "description": "application/json",
        "type": "text",
        "enabled": "true"
      })
    };
    let response = await this.http
      .post(`${appApiResources.contactList}`, search, httpOptions)
      .toPromise();
    return response;
  }

}